"use client";

import { useEffect, useState } from "react";
import Button from "@components/atoms/Button";
import styles from "../VariantCard.module.scss";
import { addCaptureIntentIfNeeded, getLoginUrl } from "@utils/getLoginUrl";
import { maskAmount } from "@utils/numberFormatter";
import { useGlobalLoader } from "@hooks/useGlobalLoader";
import { usePathname } from "next/navigation";
import { LoginSdkConfig } from '@enums/LoginSdkConfig';
import { handleLoginFlow } from "@utils/loginFlowHandler";

type Props = {
  brandName?: string;
  modelName?: string;
  title?: string;
  savings?: any;
  pageType?: any;
  location?: string;
  carAvailability?: string;
  variantSlug?: string;
};

export default function ButtonClientWrapper({
  brandName,
  modelName,
  title,
  savings,
  pageType,
  location,
  carAvailability,
}: Props) {
  const [currentUrl, setCurrentUrl] = useState("");
  const pathname = usePathname();
  const { showLoader, hideLoader } = useGlobalLoader();

  const mmvDetails = {
    make: brandName || "",
    model: modelName || "",
    variant: title || "",
    color: "",
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href);
    }
  }, []);

  useEffect(() => {
    hideLoader();
  }, [pathname, hideLoader]);

  return (
    <div className={styles.exploreButtonWrapper}>
      <div className={styles.savingLabel}>
        {`Save up to ${maskAmount(savings)}`}
      </div>
      <Button
        size="ds"
        className={styles.exploreLoggedOutButton}
        onButtonClick={async () => {
          if (typeof window !== "undefined") {
            sessionStorage.setItem("loginType", "Reveal price");
            localStorage.setItem("MMV", JSON.stringify(mmvDetails));
          }
          showLoader("Loading variant details...");
          const loginUrl = getLoginUrl(
            addCaptureIntentIfNeeded(
              currentUrl,
              mmvDetails,
              "Reveal price",
              pageType
            )
          );
          hideLoader();
          await handleLoginFlow(loginUrl, LoginSdkConfig.AD_PRICE);
        }}
        segmentEventProps={{
          eventName: "action",
          pageType,
          eventProperties: {
            action_type: "tap_btn",
            action_name: "tap_btn_login_to_save",
            section: "Variant",
            variant_name: title,
            car_availability: carAvailability,
            city_name: location,
            vehicle_make: brandName,
            vehicle_model: modelName,
          },
        }}
      >
        Check ACKO Drive price
      </Button>
    </div>
  );
}
